export const stringMapDefault = {
    overflowIconButton: "Show More Items"
};
